// Application settings
export const PURGE_AUTH = "purgeAuth";
export const AUTH_REFRESH_TOKEN = "refreshAuthTokens";
export const SET_AUTH = "setAuth";
export const SET_TIMING_OUT = "setTimingOut";
export const SET_USER_PREFERENCES = "setUserPreferences";
export const SET_ERROR = "setError";
export const SET_ARCHIVE = "setArchive";
export const SET_NOTIFICATION = "setNotifcation";
export const SET_LOADING = "setLoading";
export const SET_EDITMODE = "setEditmode";

// User Information
export const SET_USER_DATA = "setUserData";
export const SET_PROFILE_PICTURE = "setProfilePicture";

// PenPic
export const SET_IMAGE_MODAL = "imageModal";
export const SET_PENPIC_CLIENT = "setPenpicClient";

// PenPic Sidebar Settings
export const SET_ORIENTATION = "setOrientation";
export const SET_GREY_SCALE = "setGreyScale";
export const SET_CLIENT_CONFIG = "setClientConfig";
export const SET_ANONYMOUS = "setAnonymous";

// Users page
export const SET_READ_ONLY_USERS = "setReadOnlyUsers";

// Projects
export const SET_PROJECT = "setProject";
export const SET_PROJECT_DETAIL = "setProjectDetail";
export const SET_PROJECT_OPEN_SEATS = "setProjectOpenSeats";
export const SET_PROJECT_RESOURCES = "setProjectResources";
export const SET_USER_PROJECT_BOARD = "setUserProjectBoard";
export const SET_PROGRAMME = "setProgramme";
export const SET_PROGRAMME_DETAIL = "setProgrammeDetail";

// Skills
export const SET_ALL_SKILL = "setAllSkill";
export const SET_TECH_SKILL = "setTechSkill";
export const SET_SOFT_SKILL = "setSoftSkill";

// Badges
export const SET_BADGE = "setBadge";
export const SET_USER_BADGE = "setUserBadge";

// Types of data
export const SET_JOB_ROLE_SPECIALTIES = "setJobRoleSpecialties";
export const SET_BAND = "setBand";
export const SET_PRONOUN = "setPronoun";
export const SET_AGENCY = "setAgency";
export const SET_ACCOUNT = "setAccount";
export const SET_SECTOR = "setSector";
export const SET_INDUSTRY = "setIndustry";
export const SET_CURRENCY = "setCurrency";
export const SET_GROWTH_PLATFORM = "setGrowthPlatform";
export const SET_PRACTICE = "setPractice";
export const SET_SKILL = "setSkill";
export const SET_DEGREE_LEVEL = "setDegreeLevel";
export const SET_EXPERIENCE_LEVEL = "setExperienceLevel";
export const SET_ACCOUNT_GROUP = "setAccountGroup";
export const SET_LOCATION = "setLocation";
export const SET_STATUSES = "setStatuses";
export const SET_ACCESS_LEVEL = "setAccessLevel";

// Different Types
export const SET_EMPLOYEE_TYPE = "setEmployeeType";
export const SET_DOCUMENT_TYPE = "setDocumentType";
export const SET_COMMENT_TYPE = "setCommentType";

// Resources
export const SET_RESOURCE_TYPE = "setResourceType";
export const SET_RESOURCE_USER = "setResourceUser";
export const SET_RESOURCES = "setResources";

// Resource Groups
export const SET_RESOURCE_GROUPS = "setResourceGroups";
export const SET_RESOURCE_GROUP_DETAIL = "setResourceGroupDetail";

// Resource Parameters
export const SET_RESOURCE_PARAMETER = "setResourceParameter";
export const SET_RESOURCE_PARAMETER_DATA = "setResourceParameterData";

// Invoices/tscs
export const SET_TSC = "setTsc";
export const SET_TSC_DETAIL = "setTscDetail";
export const SET_USER_INVOICE = "setUserInvoice";
export const SET_USER_PURCHASE_ORDERS = "setUserPurchaseOrders";

// Roles
export const SET_CV_REVIEWER_OPEN_SEATS = "setCVReviewerOpenSeats";
export const SET_USER_ROLE = "setUserRole";
export const SET_ROLE = "setRole";
export const SET_ROLE_PERMISSION = "setRolePermission";
export const SET_PERMISSION_GROUPS = "setPermissionGroups";
export const SET_PERMISSION_GROUPS_DETAIL = "setPermissionGroupsDetail";
export const SET_PERMISSION = "setPermission";

// Candidates
export const SET_SUITABLE_CANDIDATES = "setSuitableCandidates";
export const SET_ASSIGNED_CANDIDATES = "assCan";
export const SET_CANDIDATE = "setCandidate";
export const SET_CANDIDATE_DATA = "setCandidateData";
export const SET_CANDIDATE_DETAIL = "setCandidateDetail";
export const SET_CANDIDATE_COMMENTS = "setCandidateComments";
export const SET_FILTERED_CANDIDATE = "setFilteredCandidate";
export const SET_CANDIDATE_TO_ADD = "setCandidateToAdd";
export const SET_CANDIDATE_BY_SERIAL = "setCandidatesBySerial";
export const SET_CANDIDATE_STATUS = "setCandidateStatus";
export const SET_CANDIDATE_USER = "setCandidateUser";

// Support
export const SET_SUPPORT = "setSupport";
export const SET_SUPPORT_DETAIL = "setSupportDetail";
export const SET_SUPPORT_TYPE = "setSupportType";

// Open Seats
export const SET_SEAT_STATUS = "setSeatStatus";
export const SET_OPEN_SEAT_STATUS_HISTORY = "setOpenSeatStatusHistory";
export const SET_OPEN_SEAT = "setOpenSeat";
export const SET_OPEN_SEAT_DETAIL = "setOpenSeatDetail";
export const SET_OPEN_SEAT_CANDIDATE = "setOpenSeatCandidate";
export const SET_OPEN_SEAT_STATUS = "setOpenSeatStatus";
export const SET_OPEN_SEAT_PROGRESS_STATUS = "setOpenSeatProgressStatus";
export const SET_OPEN_SEAT_TYPE = "setOpenSeatsTypes";
export const SET_CANDIDATES_BY_OPEN_SEAT_ID = "setCandidatesByOpenSeatId";
// Potentially this needs investigating to rename to candidate for open seat
export const SET_RESOURCE_FOR_OPEN_SEAT = "setResourceForOpenSeat";

// Search histories and filtering
export const SET_SEARCH_COMPONENT = "setSearchComponent";
export const SET_SEARCH_HISTORY = "setSearchHistory";
export const SET_CLUSTER_FILTER = "setClusterFilter";
export const SET_FILTER = "setFilter";
export const SET_OPEN_SEAT_FILTER = "setOpenSeatFilter";

// Settings
export const SET_RESOURCE_PARAMETERS_DATA = "setResourceParametersData";

// Emails
export const SET_EMAIL_LOGS = "setEmailLogs";
export const SET_EMAIL_LOG_DETAIL = "setEmailLogDetail";
export const SET_EMAIL_TEMPLATE = "setEmailTemplate";
export const SET_SELECTED_EMAIL_TEMPLATE = "setSelectedEmailTemplate";
export const SET_ATTACHMENTS = "setAttachments";

// Boarding
export const SET_BOARDING_STATUSES = "setOnboardingStatuses";
export const SET_OFFBOARDING_TYPES = "setOffboardingTypes";

// Reporting (potentially obsolete depending on insights/analytics)
export const SET_REPORT = "setReport";

// Charts (potentially obsolete)
export const SET_OPEN_SEATS_BY_JOB_ROLE = "setOpenSeatsByJrss";
export const SET_AVAILABLE_USERS = "setAvailableUsers";
export const SET_ACTIVE_USERS = "setActiveUsers";
export const SET_OPEN_SEATS_BY_PROJECT = "setOpenSeatsByProject";
export const SET_RESOURCES_OVER_TIME = "setResourcesOverTime";
export const SET_ACTIVE_PROJECTS = "setActiveProjects";
export const SET_AVAILABLE_PROJECTS = "setAvailableProjects";
export const SET_ACTIVE_OPEN_SEATS = "setActiveOpenSeats";
export const SET_AVAILABLE_OPEN_SEATS = "setAvailableOpenSeats";

export const SET_PERSON_ACCOUNT_CHART = "setPersonAccountChart";
export const SET_PERSON_AVAILABILITY_CHART = "setPersonAvailabilityChart";
export const SET_PERSON_BAND_CHART = "setPersonBandChart";
export const SET_RESOURCES_BY_BAND = "setPersonBandGroupChart";
export const SET_PERSON_JRSS_CHART = "setPersonJrssChart";
export const SET_PERSON_GROWTH_CHART = "setPersonGrowthChart";
export const SET_PERSON_PRACTICE_CHART = "setPersonPracticeChart";
export const SET_TECH_SKILL_OVERVIEW_CHART = "setTechSkillsOverviewChart";
export const SET_TECH_SKILL_EXPERIENCE_CHART = "setTechSkillsExperienceChart";
export const SET_PROF_SKILL_OVERVIEW_CHART = "setProfSkillsOverviewChart";
export const SET_PROF_SKILL_EXPERIENCE_CHART = "setProfSkillsExperienceChart";
export const SET_BAND_BY_ACCOUNT_CHART = "setBandByAccountChart";
export const SET_OPEN_SEAT_OVER_TIME = "setOpenSeatsOverTimeChart";
export const SET_OPEN_SEATS_BY_ACCOUNT = "setOpenSeatsByAccountChart";
export const SET_OPEN_SEAT_BY_MONTH_CHART = "setOpenSeatsByMonthChart";
export const SET_OPEN_SEAT_BY_PROJECT_CHART = "setOpenSeatsByProjectChart";
